<template>
    <CLoader :pConfigLoad="ConfigLoad">
        <template slot="BodyFormLoad">
            <div class="container-fluid">
                <form id="FormProveedores" role="form" method="post" autocomplete="off" onSubmit="return false">
                    <CList @FiltrarC="Recuperar" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
                        <template slot="Filtros">
                            <div class="col-auto">
                                <label class="col-form-label text-primary">Por</label>
                            </div>
                            <div class="col-auto">
                                <select @change="Recuperar" v-model="Filtro.IdProductoCategoria" class="form-select form-control-search">
                                    <option value="">Todos</option>
                                    <option v-for="(item,index) in Categorias" :key="index" :value="item.IdProductoCategoria">{{item.Nombre}}</option>
                                </select>
                            </div>
                        </template>

                        <template slot="header">
                            <th :class="StyleTh+' text-center'">#</th>
                            <th :class="StyleTh">Nombre Comercial</th>
                            <th :class="StyleTh">Razón Social</th>
                            <th :class="StyleTh">RFC</th>
                            <th :class="StyleTh">Categoría</th>
                            <th :class="StyleTh">Elegir</th>
                        </template>

                        <template slot="body">
                            <tr v-for="(lista,index) in Proveedores" :key="index">
                                <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					            <td><h6 :class="StylePr">{{lista.NombreComercial}}</h6></td>
                                <td><p :class="StyleTd">{{ lista.RazonSocial }}</p></td>
                                <td><p :class="StyleTd">{{ lista.RFC }}</p></td>
                                <td><p :class="StyleTd">{{ lista.productoscategoria.Nombre }}</p></td>
                                <td v-if="BndMostrarBotones">
                                    <button v-show="lista.ShowButton" @click="SeleccionarProveedor(lista)" type="button" class="btn btn-link text-primary px-3 mb-0 mr-1"><i class="fas fa-check-circle text-primary me-2"></i> Agregar</button>
                                </td>
                            </tr>
                            <CSinRegistros :pContIF="Proveedores.length" :pColspan="6"></CSinRegistros>
                        </template>
                    </CList>
                </form>
            </div>
        </template>
    </CLoader>
</template>

<script>
import Configs from '@/helpers/VarConfig.js';
export default {
    name: 'FormProveedores',
    props:['poBtnSave','pProveedorSeleccionado'],
    data() {
        return {
            ConfigLoad:{
                ShowLoader: false,
                ClassLoad: false,
            },
            Emit: this.poBtnSave.EmitSeccion,
            ConfigList:{
                Title:'Proveedores',
                BtnNewShow:false,
                ShowTitleFirst: false,
                ShowLoader: false,
                ShowFooter:false
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                IdProductoCategoria:""
            },
            segurity: {},
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            BndMostrarBotones:true,
            Proveedores:[],
            Categorias:[]
        }
    },
    methods: {
        Recuperar(){
            this.ConfigList.ShowLoader=true;
            this.$http.get('proveedores',
            {
                params:{
                    Nombre: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    IdProductoCategoria:this.Filtro.IdProductoCategoria
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.Proveedores=res.data.data.data;
                this.Proveedores.map((el)=>{return el.ShowButton=true;})
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
                this.ConfigLoad.ShowLoader = false;
            });
        },
        SeleccionarProveedor(item){
            this.bus.$emit('SeleccionarProveedor',item);
        },
        FiltrarBoton(){

        },
        ListaCategorias(){
            this.$http.get("productosCategoria/simple"
            ).then((res)=>{
                this.Categorias=res.data.data
            })
        }
    },
    created() {
        this.ListaCategorias();
        this.poBtnSave.Toast = 0;

        this.bus.$off('Recovery_'+this.Emit);
        this.bus.$on('Recovery_'+this.Emit,(Id)=>
        {
            this.poBtnSave.DisableBtn = false;
            this.Recuperar();
        });
    },
}
</script>

<style>

</style>